import React from 'react';
import { Box, useAppSelector } from '../../../base';
import { IServerJobApplicationChatMessage } from '../../../common';
import ChatMessage from './ChatMessage';
import NoChatMessages from './NoChatMessages';
import { userSelectors } from '../../../actions';

interface Props {
    messages: Array<IServerJobApplicationChatMessage>;
}

const ChatTab = (props: Props) => {
    const { messages } = props;
    const currentUser = useAppSelector(userSelectors.getMyUser);

    return (
        <Box>
            {messages && messages.length > 0 ? (
                <Box>
                    {messages.map((messageItem) => (
                        <ChatMessage
                            key={messageItem.id}
                            messageData={messageItem}
                            currentUserId={currentUser?.id}
                        />
                    ))}
                </Box>
            ) : (
                <NoChatMessages />
            )}
        </Box>
    );
};

export default ChatTab;
